import { render, staticRenderFns } from "./LoyaltyTransactionForm.vue?vue&type=template&id=40826b90&scoped=true&"
import script from "./LoyaltyTransactionForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTransactionForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyTransactionForm.vue?vue&type=style&index=0&id=40826b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40826b90",
  null
  
)

export default component.exports